<template>
  <v-app>
    <template v-if="shouldRender">
      <app-header />
      <v-main class="page-content">
        <v-container class="pt-4 pb-4 pt-md-10 pb-md-10">
          <router-view />
        </v-container>
      </v-main>
      <app-footer />
    </template>
    <c-loading-logo
      :active="!shouldRender || chunkLoading || shouldShowLoadingLogo"
    />
    <c-modal
      :width="authModalState.width"
      :persistent="true"
      :value="authModalState.shouldShow"
      @onClosed="$store.dispatch('closeAuthModal')"
    >
      <auth
        :initComponent="authModalState.component"
        :initData="authModalState.data"
      />
    </c-modal>
    <alerts />
    <v-overlay
      z-index="10"
      style="display: none"
      id="menuOverlay"
      class="d-md-none"
    ></v-overlay>
    <v-overlay
      z-index="10"
      style="display: none"
      id="menuOverlay2"
      class="d-sm-none"
    ></v-overlay>
  </v-app>
</template>

<script>
import { mapGetters } from "vuex";
import Header from "./components/layout/Header";
import Footer from "./components/layout/Footer";
import Alerts from "./components/layout/Alerts";
import Auth from "./components/auth";

export default {
  components: {
    "app-header": Header,
    "app-footer": Footer,
    Alerts,
    Auth,
  },
  data: () => ({
    shouldRender: false,
    shouldShowLoadingLogo: true,
  }),
  computed: mapGetters({
    authModalState: "authModal",
    isAuthenticated: "auth/isAuthenticated",
    isUser: "auth/isUser",
    authUser: "auth/user",
    walletSelected: "userWallets/walletSelected",
    chunkLoading: "chunkLoading",
    isMobile: "appConfig/isMobile",
  }),
  async mounted() {
    setTimeout(() => {
      this.shouldShowLoadingLogo = false;
    }, 5000);
    await Promise.all([
      this.$store.dispatch("appConfig/fetchCoins"),
      this.$store.dispatch("projectConfig/fetchNetworkConfigs"),
    ]);
    this.$store.dispatch("productStats/fetchApys");
    setTimeout(async () => {
      await Promise.all([
        this.$store.dispatch("appConfig/fetchAssets"),
        this.fetchTokenPrices(),
        this.$store.dispatch("auth/getAuth"),
      ]);
      if (this.isAuthenticated) {
        await this.fetchData();
      }
      this.watchNetworkConfigs();
      this.shouldRender = true;
      this.checkOnboarding();
    }, 1000);
    // dummy
    setInterval(() => {
      if (this.$route.name === "SolanaProjectDetails") {
        this.$store.dispatch("staking/solana/fetchRequiredInfo");
      }
      if (this.$route.name === "SuiProjectDetails") {
        this.$store.dispatch("staking/sui/fetchRequiredInfo");
      }
    }, 15000);
  },
  methods: {
    async fetchData() {
      return Promise.all([
        this.$store.dispatch("userInfo/getUserBasicInfo"),
        this.$store.dispatch("userWallets/fetchWallets"),
      ]);
    },
    watchNetworkConfigs() {
      setInterval(() => {
        if (this.$route.path.startsWith("/stake")) {
          this.$store.dispatch("projectConfig/fetchNetworkConfigs");
        }
      }, 30000);
    },
    checkOnboarding() {
      const query = this.$route.query;
      let queryData = null;
      try {
        queryData = JSON.parse(atob(query.data));
      } catch (error) {}
      if (query.ctx) {
        if (query.ctx === "onboarding") {
          if (this.isUser || queryData) {
            this.$store.dispatch("showSelectWalletModal", queryData || {});
          } else {
            this.$store.dispatch("showAuthModal", "GetStarted");
          }
        }
        history.replaceState({}, null, "?ctx=_");
      }
    },
    async fetchTokenPrices() {
      await this.$store.dispatch("appConfig/fetchTokenPrices");
      setTimeout(() => {
        this.fetchTokenPrices();
      }, 60000);
    },
  },
  watch: {
    "authUser.userId": {
      immediate: true,
      handler() {
        if (this.isAuthenticated) {
          this.$store.dispatch("websocket/init");
          if (this.shouldRender) {
            this.fetchData();
          }
        }
      },
    },
  },
};
</script>

<style lang="scss">
.page-content {
  background-color: var(--main-bg);
}
</style>
